/**
 * IPT-613 — 예외처리 등록/수정 폼의 드롭다운 옵션.
 *
 * 표기 주의: 백엔드에도 유사한 카테고리 상수(`web-filter/helpers/security-categories.ts`의
 * POLICY_CATEGORIES_39)가 있지만 표기 체계가 다르다 — 그쪽은 `인터넷 일반`·`임시 웹페이지`·
 * `커뮤니티_커뮤니티포탈`이고, 예외처리 데이터와 이 목록은 `인터넷일반`·`임시웹페이지`·
 * `커뮤니티_커뮤니티포털`을 쓴다. 운영 DB의 실제 값이 후자이므로 재사용하지 않고 따로 둔다.
 */

/** 유해차단 예외항목(상세) — IPT-613 요청 목록 그대로 (48개) */
export const WF_EXCEPT_DETAILS: readonly string[] = Object.freeze([
  '가상화폐거래_마이닝',
  '게임',
  '경영_기업',
  '공공기관차단권고',
  '기타',
  '도박',
  '동적 호스트',
  '만남주선',
  '메일 대용량 다운로드',
  '메일_웹메일',
  '메일_주요웹메일쓰기',
  '메일_주요웹메일읽기',
  '모든 정책 비활성화',
  '모바일 서비스',
  '문화_예술',
  '복권_경품_이벤트',
  '생성형 인공지능',
  '소셜미디어',
  '쇼핑',
  '스트리밍미디어',
  '스포츠',
  '엔터테인먼트',
  '웹메일',
  '웹오피스',
  '웹툰_만화',
  '웹툰_저작권위반',
  '웹하드',
  '음란물',
  '이미지_광고서버',
  '인터넷방송_UCC',
  '인터넷일반',
  '인터넷폰',
  '임시웹페이지',
  '자살_엽기_혐오_폭력',
  '전단지_리다이렉션',
  '증권',
  '증권매매',
  '증권사',
  '채팅',
  '청소년유해물',
  '커뮤니티_동호회',
  '커뮤니티_커뮤니티포털',
  '컴퓨터_인터넷_IT',
  '테러_총포·화약제조_불법',
  '투자정보',
  '프록시',
  '해킹_크레킹',
  'P2P_불법파일공유',
]);

/**
 * 저장해도 되는 처리자인지 (IPT-613).
 *
 * 허용 목록은 DB 마스터(`is_exception_actor`)에서 받아온 값을 그대로 받는다 —
 * 담당자가 바뀔 때마다 배포하지 않기 위해 프론트에 이름을 두지 않는다.
 *
 * - 빈 값은 막지 않는다 — 처리자는 필수 항목이 아니다.
 * - 목록이 비어 있으면(아직 못 받았음) 막지 않는다. 로딩 중 경고가 번쩍이면 안 된다.
 */
export const isAllowedActor = (
  actor: string | null | undefined,
  allowedActors: readonly string[],
): boolean => !actor || allowedActors.length === 0 || allowedActors.includes(actor);
